module.exports = __webpack_public_path__ + "static/img/NOTTINGHAM-MAPLE.5ae40ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/NOTTINGHAM-MAPLE.png
// module id = Rua1
// module chunks = 0